export function faq() {
  // Change the close icon in the modal on initialization
  $('.faq-card').featherlight('', {
    closeIcon:
      '<span class=\'svg js-svg-fallback svg-inline icon-icon_x\' data-filename=\'icon_x\'><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="#AF1C2E" fill-rule="evenodd" d="M9 7.5l-3-3 3-3L7.5 0l-3 3-3-3L0 1.5l3 3-3 3L1.5 9l3-3 3 3z"/></svg></span> Close'
  });

  // Element Caching -------------------------

  // Filters and Filter Groups
  let $catFilter = $('.js-faq-category-select'),
    $catParentFilter = $('.js-faq-category-parent-select'),
    $catServicesFilter = $('.js-faq-service-select'),
    $servicesGroups = $catServicesFilter.find('optgroup'),
    $backToTop = $('.js-back-to-top');

  // Items
  let $faqItems = $('.js-faq-item');

  // Clear Filters
  let $clearFiltersBtn = $('.js-faq-clear-filters');

  // ------------------------- Element Caching

  // Functions -------------------------

  let setFilters = function() {
    // $clearFiltersBtn.show();
    $clearFiltersBtn.css('opacity', 1);
    $backToTop.hide();
  };

  let clearFilters = function() {
    // $clearFiltersBtn.hide();
    $clearFiltersBtn.css('opacity', 0);
    $backToTop.show();
  };

  // ------------------------- Functions

  // Event Listeners -------------------------

  // On either filter select change
  $catFilter.on('change', function(e) {
    let selectedCat = this.value;
    let filterOn = '[data-categories~="' + selectedCat + '"]';

    // If show all or select a category...
    if (!selectedCat || selectedCat === '') {
      if ($catParentFilter.val() === '') {
        $faqItems.fadeIn();
        clearFilters();
      } else {
        $catParentFilter.trigger('change');
      }
    } else {
      // otherwise
      $faqItems.not(filterOn).fadeOut(200, function() {
        $faqItems.filter(filterOn).fadeIn(200);
      });

      setFilters();
    }
  });

  // On parent category ("type") change
  $catParentFilter.on('change', function(e) {
    $catServicesFilter.val('');
    if (this.value !== '') {
      $catServicesFilter.find('optgroup').remove();
      $catServicesFilter.append($servicesGroups.filter('[data-cat-group=' + this.value + ']'));
      setFilters();
    } else {
      $catServicesFilter.find('optgroup').remove();
      $catServicesFilter.append($servicesGroups);
      clearFilters();
    }
  });

  // Clear Filters
  $clearFiltersBtn.on('click', function(e) {
    e.preventDefault();
    $catParentFilter.val('');
    $catFilter.val('');
    $servicesGroups.show();
    $faqItems.fadeIn();
    clearFilters();
  });

  // ------------------------- Event Listeners
}



// WEBPACK FOOTER //
// ./resources/js/utils/faq.js